import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "@/store";

interface AuthRedirectProps {
  children: React.ReactNode;
}

// This component redirects authenticated users away from auth pages
const AuthRedirect = ({ children }: AuthRedirectProps) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return !isAuthenticated ? <>{children}</> : null;
};

export default AuthRedirect;
